import {Store} from './store';
import peoplePropertiesClient from 'common/report/queries/query-api/people-properties-client';

export default new Store<Array<Record<string, any>>>({
  apiClient: peoplePropertiesClient,

  defaultValue: [],
});
